'use strict';

export default function sendSuccessToPath$config(options) {
    var fromPath = options.fromPath,
        toPath = options.toPath;

    return function sendSuccessToPath(value, vm) {

        var toPathErrors = vm.errorsFor(toPath) || [];
        var noErrorForToPath = toPathErrors.length === 0 || toPathErrors[0].type === 'success';

        if (vm.path(fromPath) === vm.path(toPath) && noErrorForToPath) {
            vm.updateErrors(toPath, [{type: 'success'}]);
            return {type: 'success'};
        } else {
            // Remove success message
            [fromPath, toPath].forEach(function (path) {
                var errorsForPath = vm.errorsFor(path) || [];
                var successIdx = -1;
                errorsForPath.forEach(function (error, idx) {
                    if (error.type === 'success') {
                        successIdx = idx;
                    }
                });

                if (successIdx > -1) {
                    errorsForPath.splice(successIdx, 1);
                    vm.updateErrors(path, errorsForPath);
                }
            });
        }
    };
}


/** WEBPACK FOOTER **
 ** ./src/validators/sendSuccessToPath.js
 **/